import React from "react";

export default function Beliefs() {
    return (
        <section className="section section--soft">
            <div className="container">
                <h2 className="h-lg section-title">What we believe.</h2>
                <div className="feature-3">
                    <div className="feature-card">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <circle cx="12" cy="12" r="6"></circle>
                                <circle cx="12" cy="12" r="2"></circle>
                            </svg>
                        </div>
                        <h3>Build what fits</h3>
                        <p>Software should bend to your business, never the other way around.</p>
                    </div>
                    <div className="feature-card">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                                <path d="m9 12 2 2 4-4"></path>
                            </svg>
                        </div>
                        <h3>Own the outcome</h3>
                        <p>One accountable team from first call to long after launch.</p>
                    </div>
                    <div className="feature-card">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                            </svg>
                        </div>
                        <h3>Keep it clear</h3>
                        <p>Plain language, honest timelines, no jargon and no surprises.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
